module.exports = __webpack_public_path__ + "static/media/document2.390526c9.png";